export * from './base-dialog.class';
